import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ resource, profilePicture }) =>
    present(
      repository
        .saveProfilePicture(resource, profilePicture)
        .then((profilePicture) => ({ resource, profilePicture }))
        .catch(() => Promise.reject({ resource, profilePicture })),
    );
}

export type { Interactor };

export { createInteractor };
